<template>
    <div class="caseSearch">
         <Row :gutter="10" style="margin-bottom: 10px;">
           <div v-if="companyIdCookie==1">
             <Col span="5">
               <Select v-model="companyId" filterable :placeholder="$t('ticket.list.selectByCompany')" :transfer="true" @on-change="searchCompany()">
                 <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                 <Option :value="item.id" v-for="item in companyList" :key="item.id">{{item.name}}</Option>
               </Select>
             </Col>
           </div>
            <Col span="5">
                <Input search v-model="ticketEntityId" :placeholder="$t('ticket.list.selectByCaseId')" @on-search="searchCase()"/>
            </Col>
            <Col span="5">
                <Select v-model="priorityId" filterable multiple :max-tag-count="1" :placeholder="$t('ticket.list.selectByPriority')" :transfer="true" @on-change="searchPriority(priorityId)">
                    <Checkbox v-model="priorityIdCheckbox" @on-change="selectOurCompanyAll" style="display: block;text-align:right;">全选</Checkbox>
                    <Option :value="item.id" v-for="item in priorityIdList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
            <Col span="5">
                <DatePicker type="daterange" format="yyyy-MM-dd" placement="bottom-end" v-model="range" :placeholder="$t('ticket.list.selectByDate')" @on-change="range=$event, searchByDateRange(range)" style="width:100%" @on-clear="handleClear()"></DatePicker>
            </Col>
        </Row>
        <Row :gutter="10">
            <Col span="5">
                <Select v-model="status" filterable :placeholder="$t('ticket.list.selectByStatus')" :transfer="true" @on-change="searchStatus()">
                    <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                    <Option :value="item.id" v-for="item in statusList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
            <Col span="5">
                <Select v-model="ticketCategory" filterable :placeholder="$t('ticket.list.selectByProblemTypes')" :transfer="true" @on-change="searchTicketCategory()">
                    <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                    <Option :value="item.id" v-for="item in ticketCategoryList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
            <Col span="5">
                <Input search v-model="assigneeUserName" :placeholder="$t('ticket.list.selectByOperator')" @on-search="searchAssigneeUserName()"/>
            </Col>
            <Col span="6">
                <add-case></add-case>
            </Col>
        </Row>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../utils/cookieUtil.js'
    import AddCase from '../case/AddCase'
    import TableCase from '../case/TableCase'
    var tableCase = TableCase;
    export default {
        name: 'CaseSearch',
        components: {
            AddCase
        },
        data () {
            return {
                companyIdCookie:getCookie(global.companyId),
                ticketEntityId:'',
                priorityId:[],
                priorityIdCheckbox: false,
                companyId:'',
                companyList: [],
                assigneeUserName: '',
                priorityIdList:[
                {
                    id:0,
                    name:'P1'
                },
                {
                    id:1,
                    name:'P2'
                },
                {
                    id:2,
                    name:'P3'
                },
                {
                    id:3,
                    name:'P4'
                }],
                status:'',
                statusList:[],
                ticketCategory: '',
                createdTime: '',
                startTime: '',
                endTime: '',
                range:['',''],
                ticketCategoryList: []

            }
        },
        mounted: function(){
            if((this.$route.query.priorityId != undefined)){
                this.priorityId= JSON.parse(this.$route.query.priorityId)
            }

            if((this.$route.query.status != undefined)){
                this.status=parseInt(this.$route.query.status);
            }

            if((this.$route.query.createdTime != undefined)){
                this.createdTime=this.$route.query.createdTime;
            }

            if (this.$route.query.falg==1) {
                if(this.$route.query.priorityList !=undefined){
                    this.priorityId=JSON.parse(this.$route.query.priorityList).map(Number);
                }
                if(this.$route.query.status !=undefined){
                    this.status = parseInt(this.$route.query.status);
                }
                if(this.$route.query.ticketEntityId !=undefined){
                    this.ticketEntityId = this.$route.query.ticketEntityId;
                }
                if(this.$route.query.companyId !=undefined){
                    this.companyId = parseInt(this.$route.query.companyId);
                }
                if(this.$route.query.ticketCategory !=undefined){
                    this.ticketCategory = parseInt(this.$route.query.ticketCategory);
                }
                if(this.$route.query.createdTime !=undefined){
                    this.createdTime = this.$route.query.createdTime;
                }
                if(this.$route.query.userName !=undefined){
                    this.assigneeUserName = this.$route.query.userName;
                }
            }
            this.getCompanyDropDownBox();
            this.getTicketCategoryDropDownBox();
        },
        methods: {
            getCompanyDropDownBox: function(){
              this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
                .then(res => {
                    this.companyList = res.data;
                });
            },
            getTicketCategoryDropDownBox: function(){
                this.$api.ticket.getProblemType({})
                  .then(res => {
                      // 问题类型
                      this.ticketCategoryList=res.data.problemTypeList;
                      this.statusList = res.data.stateList;
                  })
            },
            searchCase: function(){
                this.$route.query.ticketEntityId=this.ticketEntityId;
                eventBus.$emit('ticketEntityId', this.ticketEntityId);
                tableCase.methods.showAll();
            },
            searchStatus: function(){
                this.$route.query.status=this.status;
                eventBus.$emit('status', this.status);
                tableCase.methods.showAll();
            },
            /***********优先级**************************/
            selectOurCompanyAll() {
                this.priorityId = []
                if (this.priorityIdCheckbox) {
                    this.priorityIdList.map((item) => {
                        this.priorityId.push(item.id)
                    })
                } else {
                    this.priorityId = []
                }
            },
            searchPriority: function(val){
                if (val.length === this.priorityIdList.length && val.length != 0) {
                    this.priorityIdCheckbox = true
                } else {
                    this.priorityIdCheckbox = false
                }
                this.$route.query.priorityList=JSON.stringify(this.priorityId);
                eventBus.$emit('priorityId', this.priorityId);
                tableCase.methods.showAll();
            },
            searchCompany: function(){
                this.$route.query.companyId=this.companyId;
                eventBus.$emit('companyId', this.companyId);
                tableCase.methods.showAll();
            },
            searchTicketCategory: function(){
                this.$route.query.ticketCategory=this.ticketCategory;
                eventBus.$emit('ticketCategory', this.ticketCategory);
                tableCase.methods.showAll();
            },
            searchAssigneeUserName: function(){
                this.$route.query.userName=this.assigneeUserName;
                eventBus.$emit('assigneeUserName', this.assigneeUserName);
                tableCase.methods.showAll();
            },
            handleClear: function() {
                tableCase.methods.cleanQueryData();
            },
            searchByDateRange: function(val){
              if(val[0]==""&&val[1]==""){
                this.startTime=0;
                this.endTime=0;
              } else{
                this.startTime=(new Date(val[0]));
                this.endTime=(new Date(val[1]));
                eventBus.$emit('startTime', this.startTime);
                eventBus.$emit('endTime', this.endTime);
              }
              tableCase.methods.showAll();
            }
        }
    }
</script>
<style scoped>
    .caseSearch
    {
        padding: 4px 0px 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/cases/case/CaseSearch.vue